import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Assurance } from "../../core/model/assurance";
import { AssuranceService } from "../../core/service/assurance.service";

@Component({
  selector: "app-add-assurance",
  templateUrl: "./add-assurance.component.html",
  styleUrls: ["./add-assurance.component.scss"],
})
export class AddAssuranceComponent implements OnInit {
  assurance: Assurance = new Assurance();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _assuranceService: AssuranceService) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.assurance.active = true;
    this.pressButton = true;
    this._assuranceService
      .add(this.assurance)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
